/**
 * Created by vlad.p on 7/31/2017.
 */

export class BaseSearchRequest {
    public Top: number;
    public Skip: number;
    public Query: string;
}


// WEBPACK FOOTER //
// ./app/objects/requests/baseSearchRequest.ts